let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fKeEI")).then(() => parcelRequire('fIQox'));